import { useContext, useEffect, useState } from 'react';

// Nucleus Components
import { useLazyDataModel } from '@thd-nucleus/data-sources';
import { DeliveryContext } from '../context/delivery-context';

export const useMarketCheck = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [deliveryState, dispatch] = useContext(DeliveryContext);
  const { deliveryAddress, rentalCategory, rentalSubCategory } = deliveryState;

  const variables = {
    zipcode: deliveryAddress.zipCode,
    tools: [
      {
        categoryCode: rentalCategory,
        subcategoryCode: rentalSubCategory
      }
    ]
  };

  const [getRentalMarketCheck] = useLazyDataModel('getRentalMarketCheck', {
    variables,
    ssr: false,
  });
  const executeRequest = async () => {
    setLoading(true);
    setError(null);

    try {
      const { data: marketCheckData, errors: marketCheckError } = await getRentalMarketCheck({
        variables,
      });

      if (marketCheckError) {
        throw new Error(marketCheckError);
      }
      setData(marketCheckData.getRentalMarketCheck);
    } catch (err) {
      setError(err.message || 'Unexpected Error');
      setData(null);
    } finally {
      setLoading(false);
    }

  };

  useEffect(() => {
    if (
      rentalCategory
      && rentalSubCategory
      && deliveryAddress?.zipCode.trim().length === 5
    ) {
      executeRequest();
    } else {
      setData(null);
    }
  }, [rentalCategory, rentalSubCategory, deliveryAddress?.zipCode]);

  return { data, error, loading };
};